module.exports = __webpack_public_path__ + "static/vib_play10s-61ec2b4eae2f47b6bc92bbd8b57b3451.jpg";